import platform from 'platform';

// https://github.com/bestiejs/platform.js/tree/master/doc#platformproduct
const TabletProducts = new Set(['iPad', 'Kindle', 'Kindle Fire', 'Nook', 'PlayBook']);

// https://github.com/bestiejs/platform.js/tree/master/doc#platformosfamily
const MobileFamily = new Set(['Android', 'iOS', 'Windows Phone']);

// https://stackoverflow.com/questions/58019463/how-to-detect-device-name-in-safari-on-ios-13-while-it-doesnt-show-the-correct
const isTabletSafari =
  window?.navigator?.platform === 'MacIntel'
  // @ts-expect-error
  && typeof window?.navigator?.standalone !== 'undefined'
  && window?.navigator?.maxTouchPoints > 1;

/**
 * This is NOT referring to whether or not our mobile app is running on a tablet.
 * That concept no longer exists because we devices can switch between "phone UI" and "tablet UI".
 * Devices commonly called "tablets" can still put Discord on small window sizes (e.g. via Stage Manager, Foldables).
 *
 * You probably want useWindowDimensions or derivatives such as useWindowSizeClassifer and useChatLayout.
 * Again, the mobile app can switch between phone UI and tablet UI at runtime.
 * You need to handle that switch well.
 */
const isTablet = TabletProducts.has(platform.product ?? '') || isTabletSafari;
const isMobile = !isTablet && MobileFamily.has(platform?.os?.family ?? '');
const isIOSWeb = platform?.os?.family === 'iOS';
const isAndroidWeb = platform?.os?.family === 'Android';

export {isTablet, isMobile, isIOSWeb, isAndroidWeb};
